import { Pressable, StyleSheet, View } from 'react-native';
import Constants from 'expo-constants';
import * as Clipboard from 'expo-clipboard';
import { Text } from 'app/design/primitives/text';
import { recordError } from 'app/lib/monitoring';
import { Snackbar } from 'react-native-paper';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

interface InterfaceProps {
  testID?: string;
}

export const DEV_VERSION = 'dev';

export function Version({ testID = 'version' }: InterfaceProps) {
  const [visible, setVisible] = useState<boolean>(false);
  const onDismissSnackBar = () => setVisible(false);
  const { t } = useTranslation();

  let version: string | null;
  let updateGroup: string | null;
  if (__DEV__) {
    version = DEV_VERSION;
    updateGroup = 'no update group in dev mode';
  } else {
    version = Constants.expoConfig!.version!;
    const metadata = Constants.manifest2?.metadata as Record<string, unknown> | null;
    updateGroup = metadata?.updateGroup as string;
  }

  return (
    <Pressable
      onPress={() => {
        try {
          void Clipboard.setStringAsync(
            JSON.stringify({
              version,
              updateGroup,
            }),
          );

          setVisible(true);
        } catch (error) {
          recordError(error);
        }
      }}
      style={({ pressed }) => ({ opacity: pressed ? 0.6 : 1 })}
    >
      <View style={styles.container}>
        <View style={styles.row}>
          {version ? (
            <Text style={styles.label} testID={`${testID}-build-label`}>
              {t('version.version_label', { ns: 'common' })}:
            </Text>
          ) : null}
          {version ? (
            <Text style={styles.text} testID={`${testID}-build-version`}>
              {version}
            </Text>
          ) : null}
        </View>

        <View style={styles.row}>
          {updateGroup ? (
            <Text style={styles.label} testID={`${testID}-update-label`}>
              {t('version.update_label', { ns: 'common' })}:
            </Text>
          ) : null}
          {updateGroup ? (
            <Text style={styles.text} testID={`${testID}-update-version`}>
              {updateGroup}
            </Text>
          ) : null}
        </View>
        <Snackbar
          action={{
            label: 'X',
            onPress: () => {
              onDismissSnackBar();
            },
          }}
          onDismiss={onDismissSnackBar}
          visible={visible}
        >
          {t('version.copied', { ns: 'common' })}
        </Snackbar>
      </View>
    </Pressable>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    marginTop: 20,
    marginBottom: 5,
  },
  row: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: 10,
  },
  label: {
    fontWeight: '400',
    fontSize: 10,
    color: '#1F2635',
    paddingRight: 2,
  },
  text: {
    fontWeight: '400',
    fontSize: 10,
    color: '#999999',
  },
});
